const aaa = [
	{
		path: "signatureList",
		component: () => import("@/views/signature/signatureList.vue"),
		meta:{title:'印章管理'},
	},
	{
		path: "signatureAdd",
		component: () => import("@/views/signature/signatureAdd.vue"),
		meta:{title:'印章管理'},
	},
	{
		path: "signatureSee",
		component: () => import("@/views/signature/signatureSee.vue"),
		meta:{title:'印章管理'},
	},
]
export default aaa;